import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import TagList from './TagList';
import {Dispatch, SetStateAction} from 'react';
import {IFieldModal} from '../../../pages/field-management/custom-field/constant';
import {ITag} from '../../../pages/field-management/custom-field/DraggableTag';

export interface IUserAppliedTagList {
  tagField: IFieldModal;
  selectedTags: ITag[];
}
type UserAppliedTagProps = {
  userAppliedTagList: IUserAppliedTagList[];
  setUserAppliedTagsList: Dispatch<SetStateAction<IUserAppliedTagList[]>>;
  activeDocumentId: string;
  indexName: string;
  onMutationSuccess?: () => void;
};

const UserAppliedTag = ({
  userAppliedTagList,
  setUserAppliedTagsList,
  activeDocumentId,
  indexName,
  onMutationSuccess,
}: UserAppliedTagProps) => {
  const updateUserTagsWithNewTags = (tag: ITag, itemIndex: number) => {
    // update tag array with new tag in nested list
    setUserAppliedTagsList((prev) => {
      return prev.map((item, index) => {
        if (index === itemIndex) {
          return {
            tagField: {
              ...item.tagField,
              tagValues: [tag, ...item.tagField.tagValues],
            },
            selectedTags: item.selectedTags,
          };
        }
        return item;
      });
    });
  };

  return (
    <Box className="user-applied-tag-container">
      <Box className="tag-title">
        <Typography className={`typo-text label2_size`}>
          {t('eca.documentPreviewer.taggingPanel.userAppliedTags')}
        </Typography>
      </Box>
      {!userAppliedTagList.length ? (
        <Box className="no-tag">
          <Typography className={`typo-text body2_size`}>
            {t('eca.documentPreviewer.taggingPanel.noTagApplied')}
          </Typography>
        </Box>
      ) : (
        <Box className="tag-list-container" data-testid="tag-list-item">
          {userAppliedTagList.map((item, index) => (
            <TagList
              key={item.tagField.fieldId}
              activeDocs={activeDocumentId}
              tagField={item.tagField}
              index={index}
              indexName={indexName}
              defaultSelectedTags={item.selectedTags}
              onMutationSuccess={onMutationSuccess}
              addNewTagToList={(tag: ITag) =>
                updateUserTagsWithNewTags(tag, index)
              }
            ></TagList>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default UserAppliedTag;
